<template>
  <div id="app">
    <keep-alive>
      <router-view v-wechat-title="$route.meta.title"></router-view>
    </keep-alive>
    <modal v-if="$store.state.modal"></modal>
  </div>
</template>

<script>
import modal from "../../components/modal";
export default {
  components: {},
  data() {
    return {};
  },
  components: {
    modal,
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
#app {
  user-select: none;
  width: 100%;
  height: 100%;
  // overflow: scroll;
  overflow-x: hidden;

  
}
</style>